/** Статистика цен на грузоперевозки */
export const MIDDLE_RATES_STATISTICS_ID = 570;
/** Расширенная аналитика грузоперевозок: включает в себя «Статистику цен» */
export const FORECAST_LICENSE_ID = 592;

/** labelKey / shortLabelKey — ключи i18n (ru/en в static/locales) */
export const CAR_TYPES = [
  {
    value: "tent",
    labelKey: "trace-average-rates-car-type-tent",
    shortLabelKey: "trace-average-rates-car-type-tent-short",
  },
  {
    value: "open",
    labelKey: "trace-average-rates-car-type-open",
    shortLabelKey: "trace-average-rates-car-type-open-short",
  },
  {
    value: "close",
    labelKey: "trace-average-rates-car-type-close",
    shortLabelKey: "trace-average-rates-car-type-close-short",
  },
  {
    value: "ref",
    labelKey: "trace-average-rates-car-type-ref",
    shortLabelKey: "trace-average-rates-car-type-ref-short",
  },
  {
    value: "tral",
    labelKey: "trace-average-rates-car-type-tral",
    shortLabelKey: "trace-average-rates-car-type-tral-short",
  },
  {
    value: "docker",
    labelKey: "trace-average-rates-car-type-docker",
    shortLabelKey: "trace-average-rates-car-type-docker-short",
  },
];

export const DEFAULT_CAR_TYPE = "tent";
export const DEFAULT_TONNAGE = 5; // 20 т
export const FREE_DIRECTION_CITY_IDS = [1, 3611]; // только направление СПБ -> МСК
export const FREE_DIRECTION_CAR_TYPE = "close";

export const BILLING_OPTIONS = { buy: 1, add: 2 };

/** Период по умолчанию на кнопке оплаты, если у пользователя нет оплаченного периода */
export const DEFAULT_LICENSE_DAYS = 30;
